<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/o43IhG/tc-custom/9780547705156.jpg?1734285234833" alt="This image is the cover for the book Crises of the Republic"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Crises of the Republic
      </h1>
      <p class="bookDescription body article font2">
        <b>Four thought-provoking political essays by the author of <i>The Origins of Totalitarianism</i>.</b><br/>  <br/> Taking an in-depth look at the tumult of the 1960s and ’70s, one of the great political philosophers of our era examines how these crises challenged the American form of government. “Lying in Politics” is a penetrating analysis of the Pentagon Papers that deals with the role of image-making and public relations. “Civil Disobedience” examines various opposition movements, from the Freedom Riders to the war resisters to the segregationists. And in two additional essays, Hannah Arendt delves into issues of revolution and violence.<br/>  <br/> Wise and insightful, these pieces offer historical perspective on problems and controversies that still plague the United States in the twenty-first century.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hannah Arendt
      </h2>
      
      <p class="authorDescription body article">Hannah Arendt (1906&ndash;1975) is considered one of the most important and influential thinkers of the twentieth century. She is the author of numerous articles and books, including <I>The Origins of Totalitarianism</I> and the essay collection <I>Men in Dark Times</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?746bfbd9